 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		161: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"13d06eb","1":"89cd0b9","2":"27d8628","3":"d48944e","4":"c9f3b09","5":"7fc08e1","6":"9b03322","7":"f240e1f","8":"e324838","9":"e49a002","10":"325341c","11":"5326d49","12":"d1dc5e8","13":"b459680","14":"00c5160","15":"0d5896f","16":"bb55b16","17":"2de9897","18":"d9d415e","19":"dc36bdc","20":"847680e","21":"600844c","22":"d4e7cc8","23":"c3f4517","24":"59d066f","25":"abb75cb","26":"90b892d","27":"f1ca2ad","28":"0564372","29":"809f492","30":"9929560","31":"6b5bcea","32":"649f516","33":"98ee919","34":"70a3a94","35":"ed6ba16","36":"92243cd","37":"865148d","38":"aa69c20","39":"a05d4af","40":"d7a1fb2","41":"18e8175","42":"655abb0","43":"bbefa8a","44":"3e25cab","47":"cfbf423","48":"f1134bd","49":"e3c25ce","50":"65cdcdb","51":"1d45d2c","52":"3e28591","53":"37aea9f","54":"9397da6","55":"f04dd49","56":"fb38efa","57":"d9d184e","58":"8fe1fae","59":"33bbc9b","60":"c707519","61":"f821c43","62":"2374547","63":"2845c06","64":"c9f9d4a","65":"e280cd8","66":"04d6248","67":"68f88dd","68":"1734dac","69":"56bdec6","70":"e9064f0","71":"d5b3764","72":"94e08da","73":"5dfbc9a","74":"7972519","75":"e5032a7","76":"6d5d532","77":"e5ce8d7","78":"a99c6ab","79":"488ad86","80":"5e5a3f0","81":"014df17","82":"12e7da5","83":"706575b","84":"3e4c027","85":"cbeeb91","86":"0afc6b9","87":"d3412ef","88":"408b931","89":"724167e","90":"796ae8c","91":"fcf2ab9","92":"de8361e","93":"92d76e6","94":"adb6e5d","95":"3bb556f","96":"7dedec6","97":"810a152","98":"e699950","99":"995062a","100":"d2db2f9","101":"477a9cc","102":"9d5568f","103":"47a902c","104":"6c0ece5","105":"4072726","106":"adca972","107":"b7c78a6","108":"b72421d","109":"41023c5","110":"58750db","111":"c92b6d0","112":"79ad8c4","113":"700cecc","114":"ac56aaf","115":"8c0c966","116":"7897b23","117":"8ee5eba","118":"a18edf2","119":"a86ed9d","120":"9c642c8","121":"495701e","122":"4cc8e33","123":"93b987b","124":"7bf1def","125":"105ede9","126":"f997f9e","127":"a97af22","128":"7fb588d","129":"262981e","130":"e339c32","131":"c4a3df0","132":"376515b","133":"b098fd7","134":"cdb65de","135":"5d7a218","136":"287507f","137":"63f7b20","138":"c9443a4","139":"b88f9f2","140":"da2c83a","141":"4d9cdfb","142":"2062f32","143":"ce607dc","144":"5781304","145":"2dc6b60","146":"eb5fc1d","147":"443fc77","148":"1ff6832","149":"eb933c0","150":"9a39a52","151":"423e1d8","152":"1251b85","153":"74a9692","154":"0792ea7","155":"4a5b9fc","156":"3a5da68","157":"107b4b7","158":"4a96b5e","159":"23d74b2","160":"4668433","163":"40ec463","164":"a60e8ed"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://api.omara.es/project_static/nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
